import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { Settings, UpdateSettingsDto } from '@/types'

export const settingsService = {
  getSettings: async (): Promise<Settings> => {
    return apiClient.get<Settings>(API_ENDPOINTS.SETTINGS.BASE)
  },

  uploadRegime: async (file: File): Promise<boolean> => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.patch<boolean>(API_ENDPOINTS.SETTINGS.REGIME, formData)
  },

  updateSettings: async (data: UpdateSettingsDto): Promise<Settings> => {
    return apiClient.patch<Settings>(API_ENDPOINTS.SETTINGS.BASE, data)
  },
}
